export default __webpack_public_path__ + "/dist/images/no_data_icon.svg";